"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var R = _interopRequireWildcard(require("ramda"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _ui = require("@alycecom/ui");

var _SenderGiftLanguage = _interopRequireDefault(require("../SenderGiftLanguage/SenderGiftLanguage"));

var _gift = require("../../store/gift/gift.actions");

var _gift2 = require("../../store/gift/gift.selector");

var _RequiredActions = _interopRequireDefault(require("./RequiredActions"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var recipientActions = [{
  id: 1,
  title: function title() {
    return /*#__PURE__*/_react.default.createElement("span", null, "Accept, Exchange or Donate their ", /*#__PURE__*/_react.default.createElement(_SenderGiftLanguage.default, null));
  }
}, {
  id: 2,
  title: function title() {
    return /*#__PURE__*/_react.default.createElement("span", null, "Accept or Exchange");
  }
}, {
  id: 3,
  title: function title() {
    return /*#__PURE__*/_react.default.createElement("span", null, "Accept or Donate");
  }
}, {
  id: 4,
  title: function title() {
    return /*#__PURE__*/_react.default.createElement("span", null, "Only Accept");
  }
}];
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    buttonIcon: {
      marginRight: theme.spacing(1),
      color: 'inherit'
    }
  };
});

var SelectRecipientRequirements = function SelectRecipientRequirements() {
  var classes = useStyles();
  var dispatch = (0, _reactRedux.useDispatch)();
  var originalGift = (0, _reactRedux.useSelector)(_gift2.getOriginalGift);
  var errors = (0, _reactRedux.useSelector)(_gift2.getGiftErrors);
  var isLoading = (0, _reactRedux.useSelector)(_gift2.getGiftIsLoading);
  var isProspectEmpty = (0, _reactRedux.useSelector)(_gift2.getIsRequiredProspectEmpty);

  var _useState = (0, _react.useState)(originalGift.available_recipient_actions || 1),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      selectedAction = _useState2[0],
      setSelectedAction = _useState2[1];

  var _useState3 = (0, _react.useState)(originalGift.required_actions.prospect),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      localProspect = _useState4[0],
      setLocalProspect = _useState4[1];

  var handleChangeProspectField = (0, _react.useCallback)(function (id, value) {
    setLocalProspect(_objectSpread(_objectSpread({}, localProspect), {}, {
      [id]: value
    }));
  }, [localProspect]);
  var handleChangeProspectBulk = (0, _react.useCallback)(function () {
    setLocalProspect(R.map(function (value) {
      return R.is(String, value) ? '' : false;
    }, localProspect));
  }, [localProspect]);
  var isRequiredActionsVisible = !isProspectEmpty || !originalGift.required_actions.locked;
  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    p: 3,
    pr: 2
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: "H4-Chambray",
    pl: 4,
    pb: 2
  }, "Are there any optional steps you want to include?"), isRequiredActionsVisible && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_material.Divider, null), /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: "H4-Dark",
    pb: 2,
    pt: 3
  }, "Do you want to require action from ", originalGift.recipient.first_name, " before they can accept their", ' ', /*#__PURE__*/_react.default.createElement(_SenderGiftLanguage.default, null), "?"), /*#__PURE__*/_react.default.createElement(_material.Box, {
    pb: 3
  }, /*#__PURE__*/_react.default.createElement(_RequiredActions.default, {
    actions: localProspect,
    locked: originalGift.required_actions.locked,
    handleChangeField: function handleChangeField(action, value) {
      return handleChangeProspectField(action, value);
    },
    changeProspectBulk: handleChangeProspectBulk,
    errors: errors || {}
  })), /*#__PURE__*/_react.default.createElement(_material.Divider, null)), /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: "H4-Dark",
    pb: 2,
    pt: 3
  }, "If your recipient chooses to accept their ", /*#__PURE__*/_react.default.createElement(_SenderGiftLanguage.default, null), ", they will be able to do what?"), /*#__PURE__*/_react.default.createElement(_ui.SelectFilter, {
    fullWidth: true,
    margin: "normal",
    value: selectedAction,
    onFilterChange: function onFilterChange(e) {
      return setSelectedAction(e.recipient_actions);
    },
    renderItems: function renderItems() {
      return recipientActions.map(function (action) {
        return /*#__PURE__*/_react.default.createElement(_material.MenuItem, {
          key: action.id,
          value: action.id
        }, action.title());
      });
    },
    label: "Recipient will be able to",
    name: "recipient_actions"
  }), /*#__PURE__*/_react.default.createElement(_material.Box, {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    pt: 4
  }, /*#__PURE__*/_react.default.createElement(_material.Button, {
    variant: "contained",
    color: "secondary",
    disabled: isLoading,
    onClick: function onClick() {
      return dispatch((0, _gift.giftSetGiftActionsRequest)({
        giftId: originalGift.id,
        giftActionsId: selectedAction,
        prospect: originalGift.required_actions.locked ? null : localProspect
      }));
    }
  }, /*#__PURE__*/_react.default.createElement(_ui.DashboardIcon, {
    icon: "arrow-right",
    color: "primary",
    className: classes.buttonIcon
  }), "Continue")));
};

var _default = SelectRecipientRequirements;
exports.default = _default;